import { useEffect, useState } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';

const usePreferredInGameCurrency = () => {
  const { profile, walletCurrency } = useCurrentUser();
  const preferredInGameCurrency = profile?.settings?.preferredInGameCurrency;
  const { inGameCurrency, setInGameCurrency } = useGameContext();
  useEffect(() => {
    setInGameCurrency(preferredInGameCurrency);
  }, [preferredInGameCurrency, setInGameCurrency]);
  const [inGameCurrencyState, setInGameCurrencyState] = useState(
    preferredInGameCurrency,
  );

  return {
    profileCurrency: inGameCurrency ?? inGameCurrencyState,
    setCurrency: setInGameCurrencyState,
    walletCurrency,
  };
};

export default usePreferredInGameCurrency;
